<template>
  <div class="blend">
    <MainHeader>
      {{$ml.get('Blend')}}
    </MainHeader>

    <div class="info">
      <HeadLine>
        {{ $ml.get($root.data.blend.lang.details) }}
      </HeadLine>
      <ValueField :label="$ml.get($root.data.blend.lang.capacity)" :value="parseFloat($store.getters['unit/convert']('kg', $root.data.blend.data.LoadWeight)) + $ml.get($store.getters['unit/getLabel']('kg'))"/>
    </div>
    
    <div class="stages">
      <StageItem v-for="item in $root.data.blend['data']['Stages']" :data="item"/>
    </div>
  </div>
</template>

<script>
import StageItem from './../components/blend/StageItem';
import MainHeader from './../components/common/MainHeader';
import HeadLine from './../components/common/HeadLine';
import ValueField from './../components/common/ValueField';

export default {
  components: {
    StageItem,
    MainHeader,
    HeadLine,
    ValueField,
  }
}
</script>

<style lang="scss" scoped>

.blend {
  .head-line {
    margin-bottom: 10px;
  }

  .info {
    margin-bottom: 20px;
    .value-field {
      max-width: 50%;
    }
  }
}

</style>